
  import React from "react"
  import Component from "C:/Users/Website Sketchers/project/winpenew/WinPE-main-frontend/src/layouts/index.js"
  import data from "C:\\Users\\Website Sketchers\\project\\winpenew\\WinPE-main-frontend\\.cache\\json\\layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js